// extracted by mini-css-extract-plugin
module.exports = {"EditButton":"EditButton_EditButton__tNHmQ"};